



















import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({
  name: 'bpc-header-helpdesk-link',
})
export default class HeaderAdminCalendarSwitch extends Vue {
  get isClub(): boolean {
    return this.$store.getters['centerSettings/centerType'] === 'club';
  }
  get helpdeskLink(): string {
    console.log(this.$store.getters['centerSettings/centerType']);
    if (this.isClub) {
      return 'http://faq-clubs.big-captain.com/';
    } else {
      return 'http://faq-complexes-sportifs.big-captain.com/';
    }
  }
}
